export default __webpack_public_path__ + "static/media/grocery_marker.a6bebf4e.svg";